import React, { ReactNode, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./InternalModal.scss";

interface Props {
  children: ReactNode;
  active: boolean;
  onClose: () => void;
  /** Si es false, no se cierra al pulsar fuera del panel (por defecto true) */
  closeOnBackdropClick?: boolean;
}

export default function InternalModal(props: Props) {
  const { children, active, onClose, closeOnBackdropClick = true } = props;

  useEffect(() => {
    if (!active) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        onClose();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [active, onClose]);

  return (
    <>
      {active && (
        <div
          role="presentation"
          className="internal-modal-backdrop h-100 w-100 position-fixed top-0 left-0 z-index-50 d-flex align-items-center justify-content-center bg-black-transparent"
          style={{ borderRadius: "30px" }}
          onClick={closeOnBackdropClick ? onClose : undefined}
        >
          <div
            role="dialog"
            aria-modal="true"
            className="internal-modal-panel overflow-auto mh-100 position-relative text-center bg-white rounded p-2"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="d-flex justify-content-end align-items-center w-100 mb-1">
              <button
                type="button"
                className="internal-modal-close btn btn-link text-secondary p-2 border-0"
                onClick={onClose}
                aria-label="Cerrar"
              >
                <FontAwesomeIcon icon={["fas", "times"]} size="lg" />
              </button>
            </div>
            {children}
          </div>
        </div>
      )}
    </>
  );
}
